export const FAVORITES_CATALOG_INDEX = 'FAVORITES_CATALOG_INDEX'
export const SHOP_CART_CATALOG_INDEX = 'SHOP_CART_CATALOG_INDEX'

export const ID = {
    COURIER_SELECT: 'COURIER_SELECT',
    HEADER_SELECT: 'HEADER_SELECT',
    POST_SELECT: 'POST_SELECT',
}
export const DELIVERY = {
    POST: 'post',
    PICKUP: 'pickup',
    COURIER: 'courier',
}

export const PAYMENT = {
    CASH: 'cash',
    CARD: 'card',
    CASHLESS: 'cashless',
}
